import React, { useState } from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import useScreensize from "../../hooks/useScreensize";
import LogoIcon from "../../assets/logo_icon.png";
import Siegel from "../../assets/siegel2025.png";
import KaSiegel from "./KaSiegel";

const useStyles = makeStyles(theme => ({
  footerTxt: {
    fontSize: "0.9rem"
  },
  link: {
    color: "inherit",
    textDecoration: "none"
  },
  siegel: {
    height: 200,
    width: "auto",
    position: "relative",
    cursor: "pointer",
  }
}));

const KaFooter = () => {
  const { xs, sm, md, lg, xl } = useScreensize();
  const classes = useStyles();
  const [showSiegel, setShowSiegel] = useState(false);

  const footerNav = (
    <>
      <Typography variant="body2" className={classes.footerTxt}>
        <Link className={classes.link} to="/impressum">
          Impressum
        </Link>
        {" | "}
        <Link className={classes.link} to="/datenschutz">
          Datenschutz
        </Link>
      </Typography>
    </>
  );

  return (
    <>
      <Grid container spacing={xs ? 2 : 3}>
        <Grid item xs={12} sm={3}>
          <img onClick={() => setShowSiegel(true)} src={Siegel} className={classes.siegel} alt="" />
        </Grid>
        <Grid item xs={12} sm={9}>
          {!sm && (
            <Box mb={xs ? 2 : 0} paddingTop={xs ? 0 : 4}>
              <Grid container spacing={xs ? 2 : 3}>
                <Grid item xs={12} sm={7}></Grid>
                <Grid item xs={12} sm={5}>
                  {footerNav}
                </Grid>
              </Grid>
            </Box>
          )}
          <Grid container spacing={xs ? 2 : 3}>
            <Grid item xs={12} sm={3} md={3}>
              <Typography variant="body2" className={classes.footerTxt}>
                Burgstraße 39
                <br />
                67659 Kaiserslautern
                <br />
                Deutschland
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Typography variant="body2" className={classes.footerTxt}>
                Telefon: 0631/2057760
                <br />
                Telefax: 0631/20577699
                <br />
                E-Mail:{" "}
                <a className={classes.link} href="mailto:info@stb-kaemmerer.de">
                  info@stb-kaemmerer.de
                </a>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={5} md={5}>
              <Typography variant="body2" className={classes.footerTxt}>
                Bürozeiten:
                <br />
                Mo - Do, 08:30 bis 12:00 Uhr und 13:30 Uhr bis 16:00 Uhr
                <br />
                Fr 08:30 bis 12:00 Uhr
              </Typography>
            </Grid>
          </Grid>
        </Grid>


      </Grid>
      <KaSiegel
        open={showSiegel}
        close={() => setShowSiegel(false)}
      />
    </>
  );
};

export default KaFooter;
